<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" scrollable :fullscreen="$vuetify.breakpoint.name == `xs`">
            <v-card :loading="loading" outlined>
                <v-card-title class="primary" dense>
                    <span class="headline text-uppercase white--text">{{ title }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container v-show="hasRole([`ADMIN`, `user-role:save`])">
                        <v-subheader class="title">Perfis do Usuário</v-subheader>
                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-select
                                        v-model="role.product_id"
                                        :items="products"
                                        :rules="[required]"
                                        item-text="name"
                                        item-value="id"
                                        label="Produto"
                                        placeholder="Selecione o produto"
                                        outlined
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-autocomplete
                                        v-model="role.role_id"
                                        :items="roles_product"
                                        :rules="[required]"
                                        item-text="name"
                                        item-value="id"
                                        label="Perfil"
                                        placeholder="Selecione o perfil"
                                        outlined
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="add" depressed>
                                <v-icon left>mdi-plus-circle-outline</v-icon>ADICIONAR
                            </v-btn>
                        </v-row>
                        <v-divider></v-divider>
                    </v-container>
                    <v-row>
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :loading="loading"
                        >
                            <template v-slot:item.product_name="{ item }">
                                {{ get_product_name_role(item) }}
                            </template>
                            <template v-slot:item.role_id="{ item }">
                                {{ get_role_name(item) }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="ma-2" icon :disabled="item.loading || !hasRole([`ADMIN`, `user-role:delete`])" v-on="on" @click="remove(item)">
                                            <v-icon color="error">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span style="color:#FFF">Remover</span>
                                </v-tooltip>
                            </template>                
                        </v-data-table>
                    </v-row>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close" outlined>
                        <v-icon left>mdi-close-circle-outline</v-icon>FECHAR
                    </v-btn>
                    <v-btn color="primary" @click="save" :disabled="!hasRole([`ADMIN`, `user-role:save`])">
                        <v-icon left>mdi-content-save-outline</v-icon>SALVAR
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import { required } from '@/utils/roles.js'
    export default {
        data: () => ({
            loading: null,
            valid: null,
            lazy: false,
            role: {},
            headers: [
                { sortable: true, text: 'Produto', value: 'product_name' },
                { sortable: true, text: 'Perfil', value: 'role_id' },
                { sortable: false, text: 'Ações', value: 'actions', align: 'center', width: '5%' }
            ],
            items: []
        }),
        computed: {
            ...mapState('product', ['products']),
            ...mapState('role', ['roles']),
            ...mapGetters('app', ['hasRole']),
            title() { return 'Perfis do Usuário: '+ this.user.username },
            dialog: {
                get() { return this.value },
                set(v) { this.$emit('input', v) }
            },
            roles_product() {
                var context = this
                var { product_id } = this.role
                if (product_id) {
                    var roles_filtred = []
                    
                    var roles = context.roles.filter(r => r.product_id == product_id)
                    roles.forEach(r => {
                        if (context.items.filter(i => i.role_id == r.id).length == 0) {
                            roles_filtred.push(r)
                        }
                    });

                    return roles_filtred
                }
                return []
            }
        },
        mounted() {
            this.search(this.user)
        },
        methods: {
            required,
            add() {
                if (this.$refs.form.validate()) {
                    this.items.push({ role_id: this.role.role_id })
                }
            },
            remove({ role_id }) {
                var index = false
                for (var i = 0; i < this.items.length; i++) {
                    if (index === false) {
                        if (this.items[i].role_id == role_id) {
                            index = i
                        }
                    }
                }
                this.items.splice(index, 1)
            },
            async save() {
                await this.axios.post(this.$store.state.url_api + '/user/' + this.user.id +'/roles', this.items)
                this.close()
            },
            search({ id }) {
                if (!id) return ;
                var context = this
                context.loading = true
                this.axios.get(this.$store.state.url_api + '/user/' + id +'/roles')
                    .then(r => context.items = r.data)
                    .catch(() => context.loading = false)
                    .finally(() => context.loading = false)
            },
            close() {
                this.dialog = false
                this.$refs.form.reset()
            },
            get_role_name({ role_id }) {
                if (role_id) {
                    return this.roles.filter(r => r.id == role_id)[0].name
                }
                return 'Perfil não encontrado'
            },
            get_product_name_role({ role_id }) {
                var role = this.roles.filter(r => r.id == role_id)[0]
                if (role) {
                    var product = this.products.filter(p => p.id == role.product_id)[0]
                    if (product) {
                        return product.name
                    }
                }
                return 'Produto não encontrado'
            }
        },
        props: {
            value: Boolean,
            user: {
                type: Object,
                required: true
            }
        },
        watch: {
            user(val) {
                this.search(val)
            }
        }
    }
</script>